import axios from 'axios';

export default {
  state: {
    rules: [],
    checksLoading: false,
    checks: [],
    rulesSchema: {},
  },
  mutations: {
    setRules(state, rules) {
      state.rules = [...(rules || [])];
    },
    addCheck(state, check) {
      state.checks = [...state.checks, check];
    },
    setChecks(state, checks) {
      state.checks = [...(checks || [])];
    },
    setChecksLoading(state, loading) {
      state.checksLoading = loading;
    },
    setRulesSchema(state, response) {
      state.rulesSchema = response;
    },
  },
  getters: {
    getRules(state) {
      return state.rules;
    },
    getRulesSchema(state) {
      return state.rulesSchema;
    },
  },
  actions: {
    getConfigRules(context) {
      return axios.get(`/api/config/rules/`).then((response) => {
        context.commit('setRules', response.data.data.rules);
        return context.state.rules;
      });
    },
    getConfigChecks(context) {
      context.commit('setChecksLoading', true);
      return axios.get(`/api/config/checks/`).then((response) => {
        context.commit('setChecks', response.data);
        context.commit('setChecksLoading', false);
        return context.state.checks;
      });
    },
    createCheck(context, check) {
      return axios.post(`/api/config/checks/`, check).then((response) => {
        return response.data.check;
      });
    },
    updateCheck(context, check) {
      return axios
        .put(`/api/config/checks/${check.id}/`, check)
        .then((response) => {
          return response.data.check;
        });
    },
    deleteCheck(context, checkId) {
      return axios.delete(`/api/config/checks/${checkId}`);
    },
    getConfigRulesSchema(context) {
      axios.get(`/api/config/rules/schema/`).then((response) => {
        context.commit('setRulesSchema', response.data);
        return context.state.rulesSchema;
      });
    },
    updateConfigRules({ commit }, rules) {
      return axios.put(`/api/config/rules/`, rules).then((response) => {
        commit('setRules', response.data.data.rules);
        return response;
      });
    },
  },
};
